import React from 'react';
import { Shield, Award, Clock, CheckCircle } from 'lucide-react';

export const Guarantees: React.FC = () => {
  const guarantees = [
    {
      icon: Shield,
      title: 'Garantia de Fábrica',
      description: 'Todas as motos possuem garantia total de 1 ano sem limite de quilometragem',
      color: 'text-blue-600',
      bgColor: 'bg-blue-50',
    },
    {
      icon: Award,
      title: 'Originalidade Garantida',
      description: 'Todas as peças são originais Honda com selo de autenticidade',
      color: 'text-green-600',
      bgColor: 'bg-green-50',
    },
    {
      icon: Clock,
      title: 'Revisão Grátis',
      description: 'Primeira revisão totalmente gratuita em até 30 dias ou 1.000 km',
      color: 'text-purple-600',
      bgColor: 'bg-purple-50',
    },
    {
      icon: CheckCircle,
      title: 'Inspeção Completa',
      description: 'Todas as motos passam por rigorosa inspeção antes da entrega',
      color: 'text-orange-600',
      bgColor: 'bg-orange-50',
    },
  ];

  return (
    <section className="py-16 bg-white">
      <div className="container-custom">
        <div className="text-center mb-12">
          <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
            Garantia e Segurança
          </h2>
          <p className="text-lg text-gray-600">
            Compre com total confiança e segurança
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {guarantees.map((guarantee, index) => {
            const Icon = guarantee.icon;
            return (
              <div key={index} className="card p-6 text-center">
                <div className={`${guarantee.bgColor} w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4`}>
                  <Icon size={32} className={guarantee.color} />
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-3">
                  {guarantee.title}
                </h3>
                <p className="text-gray-600">
                  {guarantee.description}
                </p>
              </div>
            );
          })}
        </div>

        <div className="mt-12 bg-gradient-to-r from-primary-50 to-blue-50 rounded-xl p-8">
          <div className="text-center">
            <h3 className="text-2xl font-bold text-gray-900 mb-4">
              Selos de Qualidade
            </h3>
            <div className="flex flex-wrap justify-center items-center gap-8">
              <div className="bg-white rounded-lg p-4 shadow-md">
                <img
                  src="https://trae-api-us.mchost.guru/api/ide/v1/text_to_image?prompt=Selo%20de%20garantia%20Honda%20original%2C%20design%20profissional%2C%20logo%20Honda&image_size=square"
                  alt="Selo Honda Original"
                  className="h-16 mx-auto"
                />
                <p className="text-sm text-gray-600 mt-2">Honda Original</p>
              </div>
              
              <div className="bg-white rounded-lg p-4 shadow-md">
                <img
                  src="https://trae-api-us.mchost.guru/api/ide/v1/text_to_image?prompt=Selo%20de%20qualidade%20ISO%209001%2C%20certifica%C3%A7%C3%A3o%20de%20qualidade&image_size=square"
                  alt="Certificação ISO 9001"
                  className="h-16 mx-auto"
                />
                <p className="text-sm text-gray-600 mt-2">ISO 9001</p>
              </div>
              
              <div className="bg-white rounded-lg p-4 shadow-md">
                <img
                  src="https://trae-api-us.mchost.guru/api/ide/v1/text_to_image?prompt=Selo%20de%20seguran%C3%A7a%20e%20confian%C3%A7a%2C%20escudo%20verde%2C%20prote%C3%A7%C3%A3o&image_size=square"
                  alt="Site Seguro"
                  className="h-16 mx-auto"
                />
                <p className="text-sm text-gray-600 mt-2">Site Seguro</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};